import { useMemo } from "react";
import {
  Box,
  Checkbox,
  Chip,
  IconButton,
  ListItemText,
  MenuItem,
  Select,
  type SelectChangeEvent,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { type ISelectObject } from "@/types/select";

interface IProps {
  value: string[];
  onChange: (value: string[]) => void;
  options: ISelectObject[];
  disabled?: boolean;
}

/**
 * 商業登記モニタリング用の登記原因マルチセレクトコンポーネント
 * 複数選択した場合は、いずれかの登記原因に一致すればヒットする（OR一致）
 */
export const CommercialMonitoringReceptionReasonSelect: React.FC<IProps> = (
  props
) => {
  const { value, onChange, options, disabled } = props;

  const selectedOptions = useMemo(
    () => options.filter((option) => value.includes(option.value)),
    [value, options]
  );

  const handleChange = (event: SelectChangeEvent<string[]>): void => {
    const selected = event.target.value;
    onChange(typeof selected === "string" ? selected.split(",") : selected);
  };

  const handleClearClick = (): void => {
    onChange([]);
  };

  return (
    <Select
      id="commercial-monitoring-reception-reason-select"
      value={value}
      fullWidth
      multiple
      disabled={disabled}
      displayEmpty
      onChange={handleChange}
      sx={{
        "#commercial-monitoring-reception-reason-select": {
          pr: 0,
        },
      }}
      renderValue={() =>
        selectedOptions.length === 0 ? (
          "指定なし"
        ) : (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selectedOptions.map((option) => (
              <Chip key={option.value} label={option.label} size="small" />
            ))}
          </Box>
        )
      }
      endAdornment={
        !disabled && value.length > 0 ? (
          <IconButton
            sx={{ marginRight: "18px" }}
            onClick={handleClearClick}
            onMouseDown={(event) => {
              // クリア操作が Select 本体へ伝播しドロップダウンが開くのを防ぐ
              event.stopPropagation();
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        ) : undefined
      }
    >
      {options.map((option) => (
        <MenuItem key={`reception-reason-${option.value}`} value={option.value}>
          <Checkbox checked={value.includes(option.value)} />
          <ListItemText primary={option.label} />
        </MenuItem>
      ))}
    </Select>
  );
};
